import { render, staticRenderFns } from "./DcPaymentWebsocket.vue?vue&type=template&id=1ccd4354"
import script from "./DcPaymentWebsocket.vue?vue&type=script&lang=js"
export * from "./DcPaymentWebsocket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports